module.exports = require('../../es/symbol');

require('../../modules/esnext.symbol.dispose');

require('../../modules/esnext.symbol.observable');

require('../../modules/esnext.symbol.pattern-match');